<template>
  <div
    class="bg-white rounded-lg border border-gray-200 p-4 hover:border-emerald-200 transition-colors cursor-pointer"
    @click="flipped = !flipped"
  >
    <div v-if="!flipped">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <h3 class="text-xl font-bold text-gray-900">{{ word.word_vietnamese }}</h3>
          <AudioButton :src="word.audio_url || `/audio/vocab/${word.id}_word.wav`" />
        </div>
        <span class="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded">{{ word.part_of_speech }}</span>
      </div>
      <!-- Hidden when the romanization just repeats the word (adds nothing). -->
      <p v-if="romanizationDiffers(word)" class="text-sm text-gray-500 mt-1">
        <span class="text-[10px] uppercase tracking-wide text-gray-400 mr-1">{{ word.part_of_speech === 'letter' ? 'called' : 'pronounced' }}</span>{{ word.word_romanization }}
      </p>
      <!-- IPA phonetic guide is unreliable for single letters (often spells the letter's
           name, not its sound), so it's hidden for letters and kept for ordinary vocab. -->
      <PhoneticGuide v-if="word.part_of_speech !== 'letter'" :ipa="word.phonetic_ipa" :simplified="word.phonetic_simplified" />
      <p class="text-sm text-emerald-700 font-medium mt-2">
        <span v-if="word.part_of_speech === 'letter'" class="text-[10px] uppercase tracking-wide text-emerald-600 mr-1">sound</span>{{ word.part_of_speech === 'letter' ? word.word_english.replace(' sound', '') : word.word_english }}
      </p>
      <StrengthDots v-if="word.strength != null" :strength="word.strength" class="mt-2" />
    </div>
    <div v-else>
      <div class="text-sm text-gray-600 space-y-2">
        <div>
          <div class="flex items-center gap-2">
            <span class="font-medium text-gray-800">Example:</span>
            <AudioButton :src="word.example_audio_url || `/audio/vocab/${word.id}_example.wav`" />
          </div>
          <p class="text-gray-900 mt-0.5">{{ word.example_sentence_vn }}</p>
          <p class="text-gray-500 mt-0.5">{{ word.example_sentence_en }}</p>
        </div>
        <div v-if="word.southern_pronunciation_notes" class="bg-amber-50 text-amber-800 px-3 py-2 rounded text-xs">
          Southern note: {{ word.southern_pronunciation_notes }}
        </div>
      </div>
    </div>
    <p class="text-xs text-gray-300 mt-2">{{ flipped ? 'Click to see word' : 'Click for details' }}</p>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import AudioButton from './shared/AudioButton.vue'
import PhoneticGuide from './shared/PhoneticGuide.vue'
import StrengthDots from './shared/StrengthDots.vue'
import { romanizationDiffers } from '../utils/vocab'

defineProps({
  word: { type: Object, required: true },
})

const flipped = ref(false)
</script>
